export const THREE_SITE_PI_ALLOWED = 'At most 3 delegation can be added.';
export const SELECT_WORKFLOW_FIRST = 'Please select "Applying IRB / REC" before adding Site PI.';
export const TEAM_MEMBER_FORM_COMPLETENESS = 'Please check the form for completeness.';
export const NO_SITE_PI_EXIST = 'Please add at least 1 site pi';
export const NO_ALPHABET = 'Alphabet is not allowed.';
export const CO_EXIST_HOSPITAL = 'Only 1 Site PI is allowed for the same hospital.';
export const UPDATE_APPLICATION_DETAIL_SUCCESS = 'Application details has been updated.';
export const EMAIL_EXIST_EMAIL =
    'Email account is already existed in the Team Member Form. Please enter another email.';
export const HOSPITAL_EXIST_IS_SITE_MEMBER =
    'Hospital/Institution is already existed in the Team Member Form. Please enter another Hospital/Institution.';
export const INVALID_USER_IN_TEAM_MEMBER =
    'You must be either Coordinating Investigator or Delegate of Coordinating Investigator in the application form.';

export const CONFIRM_TO_SEND_TO_CI =
    'Unsaved changes will be updated before submitting Site Info. Are you sure to submit Site Info?';
export const AT_LEAST_ONE_SITE_PI = 'Delete failed. You cannot remove all Site PI.';
export const NOTIFY_CI_SUCCESS =
    'Site Info has been successfully submitted. Please submit Study Info by Coordinating Investigator.';

export const COMPLETE_BEFORE_NOTIFY = 'Please complete the following before sending to Coordinating Investigator.';
export const COMPLETE_BEFORE_SUBMIT =
    'Unsaved changes will be updated before submission. Are you sure to submit the form?';

export const FORM_SUBMIT_TIPS = 'Please complete the following before submitting the application form.';
export const SI_DELETE_CONFIRM = 'Related site data will be removed. Are you sure to delete the Site PI now?';
export const SI_CREATE_CONFIRM = 'New site is added to the application.';

export const SAVE_APPLICATION_DATA = 'Are you sure to save the changes?';

export const CONFIRM_APPLICATION_SUCCESS = 'Application has been confirmed!';
export const REJECT_SUCCESS = 'Request for return has been rejected.';

export const GENERAL_CONFIRM_SUCCESS = 'Confirm successfully.';

export const REQUEST_FOR_RETURN_TIPS = 'Are you sure to request for return?';
export const REQUEST_FOR_RETURN_SUCCESS = 'Request for return has been sent.';

export const RETURN_APPLICATION_SUCCESS = 'Application is returned.';
export const CONFIRM_REQUEST_TO_RETURN_CONFIRM = 'Are you sure to confirm the request for return?';
export const CONFIRM_REQUEST_FOR_RETURN_SUCCESS = 'Return successfully.';

export const REJECT_RETURN_OF_REQUEST_TIPS = 'Are you sure to reject the request for return?';

export const CONFIRM_RETURN_TO_CLUSTER_ADMIN = 'Are you sure to return to Cluster Admin?';

export const CONFIRM_TO_SAVE_AMENDMENT = 'Are you sure to save the amendment application form?';

export const SUSPEND_SUCCESS = 'Study site has been suspended.';
export const CONFIRM_TO_LEAVE_AMENDMENT = 'Are you sure to discard the changes?';

export const UPDATE_APPLICATION_FORM_FAIL = 'Update failed.';

export const APP_FORM_STATUS_NOT_MATCH =
    'Initial application status has been changed, please refresh the page and try again.';

export const SUSPEND_FAIL = 'Suspend failed.';
export const UPLOAD_FILE_FAILED = 'Upload file failed.';

export const SI_DELETE_REMINDER = 'Are you sure to remove the site?';

export const AMEND_FORM_SAVE_SUCCESS = 'Update successfully.';

export const LOGIN_SESSION_EXPIRED = 'Login session expired. Please login again.';
// export const REFRESH_TOKEN_ERROR = 'User credential problem, please login again';

export const AMENDMENT_SUBMIT_SUCCESS = 'Amendment application form has been submitted.';

//
export const APPLICATION_WITHDRAWN_SUCCESS = 'Application is withdrawn.';
// export const APPLICATION_WITHDRAWN_TIPS = 'Are you sure to withdraw the application?';
export const APPLICATION_DISCARD_TIPS = 'Are you sure to discard the application?';
export const APPLICATION_DISCARD_SUCCESS = 'Application is discarded.';
export const APPLICATION_RETURN_TO_SITE_SUCCESS = 'Application is returned to study site.';
export const APPLICATION_WITHDRAW_SUCCESS = 'Application is withdrawn.';
export const APPLICATION_WITHDRAW_TIPS = 'Are you sure to withdraw the application?';
export const APPLICATION_VERIFY_SUCCESS = 'Application is verified.';
export const APPLICATION_DISTRIBUTE_SUCCESS = 'Application is distributed.';

export const GENERAL_TERMINATE_TIPS = 'Are you sure to terminate?';
export const GENERAL_TERMINATE_SUCCESS = 'Terminated successfully.';
export const GENERAL_RETURN_CI_SUCCESS = 'Return to site successfully.';
export const GENERAL_FOR_REVIEW = 'Are you sure to review?';
export const GENERAL_WITHDRAWN_SUCCESS = 'Withdraw successfully.';
export const GENERAL_WITHDRAWN_TIPS = 'Are you sure to withdraw?';
export const GENERAL_DISCARD_TIPS = 'Are you sure to discard?';
export const GENERAL_SUBMIT_SUCCESS = 'Submitted successfully.';
export const GENERAL_SUBMIT_TIPS = 'Are you sure to submit?';
export const GENERAL_RETURN_TIPS = 'Are you sure to return?';
export const GENERAL_RETURN_SUCCESS = 'Return successfully.';
export const GENERAL_RETURN_TO_CLUSTER_ADMIN = 'Application is returned to cluster admin.';
export const GENERAL_RE_SUBMIT_TIPS = 'Are you sure to re-submit?';
export const GENERAL_RE_SUBMIT_SUCCESS = 'Re-submit successfully.';
export const GENERAL_VERIFY_TIPS = 'Are you sure to verify?';
export const GENERAL_VERIFY_SUCCESS = 'Verify success.';
export const GENERAL_DISTRIBUTE_TIPS = 'Are you sure to distribute?';
export const GENERAL_SAVE_SUCCESS = 'Save successfully.';
export const GENERAL_SAVE_TIPS = 'Are you sure to save?';

export const GENERAL_DISTRIBUTE_SUCCESS = 'Distribute successfully.';
export const COMPARE_CHANGE_TIPS =
    'Amendment Application form will be re-generated. The following fields will be cleared:';
export const COMPARE_CHANGE_REMINDER =
    'Changes detected, please save the current changes and complete necessary fields.';
export const DOWNLOAD_AMENDMENT_FORM = 'Please complete the amendment form before downloading it for signature(s).';
export const COMPLETE_BEFORE_AMENDMENT_SUBMIT = 'Please complete the form before submission.';
export const CONFIRM_REMOVE_CI_DELEGATION = 'Are you sure to remove the Coordinating Investigator delegation?';
export const CONFIRM_REMOVE_PI_DELEGATION = 'Are you sure to remove the study site delegation?';

export const GENERAL_CONFIRM = 'Are you sure to confirm?';
export const AMENDMENT_RETURN_TIPS = 'Are you sure to return the application?';

export const CONFIRM_AMENDMENT = 'Are your sure to confirm the amendment application form?';
export const CONFIRM_UPDATE_DELEGATE = 'Are you sure to update the delegation?';

export const CHECK_SITE_SEND = 'Please ensure all study site info has been sent to Coordinating Investigator.';

export const AMENDMENT_SUBMIT_TIPS = 'Please upload signed amendment form before submission.';
export const AMENDMENT_CONFIRM_SUBMIT_TIPS = 'Are you sure to submit the amendment application form?';
export const AMENDMENT_CONFIRM_RE_SUBMIT_TIPS = 'Are you sure to re-submit the amendment application form?';

export const GENERAL_CONSOLIDATION_SUCCESS = 'Consolidated successfully.';

export const AMENDMENT_NOT_EXIST = 'Amendment form cannot be downloaded if no change has been made.';

export const AMENDMENT_FORM_CHANGE_UPLOAD =
    'Signed amendment form should be re-uploaded by the applicant due to amendment changes.';

// export const CI_DELEGATION_NOT_PI_MEMBER = 'CI delegate cannot be site pi member';

export const CHECK_FORM_COMPLETENESS = 'Please check the form for completeness.';
export const APPLICATION_CHECK_FORM_COMPLETENESS = 'Please check the completeness of the application form.';

export const TERMINATE_CONFIRM = 'Are you sure to terminate the study?';

export const DRAFT_CREATE = 'Draft application is created.';

export const SITE_REMOVED = 'Study site is removed.';

export const TEAM_MEMBER_EXIST = 'Team member existed. Please add another one.';

export const DELEGATION_UPDATED = 'Delegation updated.';

export const TABLE_ROW_REMOVE = 'Are you sure to remove data?';

export const FINAL_REPORT_SUBMIT = 'Are you sure to submit?';

export const CTI_CREATED = 'CTC/CTI submission created.';
export const CTC_CTI_RE_SUBMITED = ' Submission re-submitted.';

export const EXPIRY_DATE_UPDATED = 'Expiry date updated.';

export const PROFILE_CONFIRM = 'Are you sure to update the profile?';

export const PROFILE_UPDATED = 'Profile updated.';
export const CONFIRM_PASSCODE_NOT_MATCH = 'Confirm password does not match with the new password.';
export const PASSCODE_POLICY_TIPS = 'Please follow the password requirement for new password.';
export const PASSCODE_UPDATED = 'Updated successfully.';
export const LOGOUT_CONFIRM = 'Are you sure to logout?';
export const SITE_RESUME = 'Are you sure to resume the study site?';
export const SITE_RESUME_UPDATED = 'Study site is resumed.';
export const TEXT_OVERFLOW = 'Field(s) in the form exceeded text limit.';
export const SITE_RETURNED_TIPS = 'Are you sure to return to study site?';
export const CTA_SUBMITTED = 'CTA submitted.';
export const EMAIL_DOMAIN_CREATED = 'Email domain has been updated.';
export const EMAIL_DOMAIN_DELETED = 'Email domain deleted.';
export const EMAIL_TEMPLATE_CREATED = 'Email template has been updated.';
export const USER_ACCOUNT_CREATED = 'User account created.';
export const SUSPEND_TIPS = 'Leave your reasons.';
export const REJECT_CONFIRM = 'Are your sure to reject the registration?';

export const SORTING_ERROR = 'Sorting failed.';

//newly since in 20220113
export const DATE_NOT_VALID = 'Please enter a valid actual study start date before downloading the document.';
export const DATE_NOT_VALID_BEFORE_SUBMIT = 'Please enter a valid actual study start date before submission.';
export const LOGOUT_FROM_ANOTHER_TAB = 'You have logout from another tab, application will be refreshed.';

export const CONFIRM_TO_SAVE_AMENDMENT_FORM = 'Are you sure to save the amendment form?';
export const SAVE_AMENDMENT_SUCCESS = 'Save successfully.';

// export const AMENDMENT_WARN_TIPS = '*Previous saved work on amendment form will be cleared';

export const SAVE_BEFORE_NAVIGATION =
    'Changes detected, are you sure to save the current changes before navigate to another tab?';

export const DISCARD_CONFIRM = 'Changes will be discarded, are you sure to leave?';

export const SI_EDIT_CONFIRM = 'Site has been updated successfully.';

export const ARRANGE_REVIEW_ARRANGEMENT_CONFIRM =
    'Application has been confirmed! Do you want to arrange review arrangement?';

export const CTA_REQUIRED = "You haven't uploaded any CTA/CTA Amendment!";

export const EDIT_EMAIL_CONFIRM = 'Are you sure to edit email? All input data will be cleared.';
export const NO_INPUT_DATA_MODIFIED = 'No input data has been modified.';
export const CREATED_REVIEWER = 'Reviewer has been created.';
export const UPDATED_REVIEWER = 'Reviewer account has been updated.';
export const DELETED_REVIEWER = 'Reviewer account has been deleted.';
export const DELETED_REVIEW_PANEL = 'Review Panel has been deleted.';
export const CREATED_REVIEW_PANEL = 'Review Panel has been created.';
export const UPDATED_REVIEW_PANEL = 'Review Panel has been updated.';
// export const USER_NOT_FOUND = 'User is not found.';
export const NO_MEMBER_DATA = 'Not selected member data.';
export const NO_APPLICATION_DATA = 'Not selected application document data.';
export const NO_CHAIRMAN = 'More than one chairman must be selected.';
export const CREATED_ARRANGE_MEETING = 'Arrange meeting has been created.';
export const EDITED_ARRANGE_MEETING = 'Arrange meeting has been edited.';
export const CREATED_CONFIRM_RESULT = 'Confirm review result has been created.';
export const EDITED_ARRANGE_MEETING_NOTIFICATION = 'Do you want to notify the reviewer for the review process?';

export const CONSOLIDATION_CONFIRM = 'Are you confirm to consolidate?';
export const CONSOLIDATION_SAVED = 'Consolidation form saved.';
export const ABORT_TEAM_MEMBER_FORM = 'Unsaved data will be discarded, are you sure to leave?';
export const SELECT_ONE = 'Please select at least one application before confirming.';
export const SELECT_ONE_REVIEWER = 'Please select at least one reviewer before confirming.';
export const SAVE_BEFORE_PRINT = 'Initial application form has changed, are you sure to save before printing?';

export const CHANGES_DETECTED = 'Amendment has been made, are you sure to save the changes?';

export const SAVE_BEFORE_DOWNLOAD_APPROVAL_LETTER =
    'Are you sure to save the consolidation before download approval letter?';
export const POST_APPROVAL_SAVE_BEFORE_PRINT = 'Form has changed, are you sure to save before printing?';
export const FORM_SAVE_BEFORE_PRINT = "Form hasn't saved, are you sure to save before printing?";

export const PLEASE_COMPLETE_THE_FORM = 'Please check the form completeness before submission.';

export const ERROR_MAX_LENGTH =
    'Some input field has exceed max length limitation, please check before saving the form.';
export const APPLICATION_UPDATE_SUCCESS = 'Application details have been updated.';

export const UPDATE_APPLICATION_FROM_CLUSTER =
    'Site PI information will be cleared, are you sure to update the workflow?';

export const MULTIPLE_LOGIN_LOGOUT = 'Your account has been logged-in in another location.';

export const VALUE_DUPLICATED = 'Variable is duplicated.';

export const PANEL_NAME_EXISTED = 'Panel name is existed in system, please modify to another one.';

export const POST_APPROVAL_DISCARD_TIPS = 'Are you sure to discard the application?';
export const POST_APPROVAL_DISCARD_SUCCESS = 'Application is discarded.';

export const ABNORMAL_ACCOUNT_STATUS = 'Abnormal account status, please login again.';

export const ACCOUNT_PENDING_FOR_ACTIVATE = 'Account is pending for activation, please check the activation email.';
export const ACCOUNT_DISABLED = 'Account is disabled, please contact administrator.';

export const ACCOUNT_ABNORMAL = 'Account status is abnormal, please contact administrator.';
